import { createAsyncThunk } from "@reduxjs/toolkit";
import { getErrorPayload } from "@application/helpers/api-helper";
import ImportantInfoApi from "@infrastructure/important-info-api";
export const ImportantInfoRegistertionAsync = createAsyncThunk("importantInfo/registration", async (importantInfo, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ImportantInfoApi.Registeration(importantInfo);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const GetByPersonAsync = createAsyncThunk("importantInfo/getByPerson", async (PersonId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ImportantInfoApi.GetByPerson(PersonId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
